import React from 'react';
import { getFieldValue } from '../../../contentful/mappers';
import './LinksGrid.css';

function LinksGrid({ data }) {
  if (!data) return null;

  const headline = getFieldValue(data, 'headline');
  const links = getFieldValue(data, 'links') || [];

  return (
    <section className="links-grid-section">
      <div className="container">
        {headline && <h2 className="section-headline">{headline}</h2>}
        <div className="links-grid">
          {links.map((link, index) => {
            const label = getFieldValue(link, 'label');
            const url = getFieldValue(link, 'url');
            const description = getFieldValue(link, 'description');
            
            return (
              <a
                key={link.sys?.id || index}
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                className="link-item"
              >
                <h3 className="link-label">{label}</h3>
                {description && <p className="link-description">{description}</p>}
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default LinksGrid;

